import { InitAction } from "../actions";
import Store from "../configureStore";

export default name => {
  const user = Store.getState().User.data;
  if (user && !user.name && !user.family) {
    Store.dispatch(InitAction.completeUserInfoConfirmData({ name: name }));
    return false;
  }
  return true;
};
